import { DEVICE_MODEL_TYPE } from "@tm/types";
import { getDeviceModelType } from "@tm/utility";

function base64ToBlob(base64: string): Blob {
  const byteChars = atob(base64);
  const byteNumbers = new Uint8Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }
  return new Blob([byteNumbers], { type: "application/pdf" });
}

/**
 * Converts a base64-encoded PDF string and either downloads it (browser)
 * or opens it in a new tab (webview, where anchor.download is unsupported).
 */
export const savePdfFromBytes = (base64: string, fileName: string): void => {
  const blob = base64ToBlob(base64);
  const blobUrl = URL.createObjectURL(blob);

  if (getDeviceModelType() === DEVICE_MODEL_TYPE.APP) {
    window.open(blobUrl, "_blank");
    return;
  }

  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(blobUrl);
};
